const CARRIER_LOGO_MAP: { patterns: string[]; path: string }[] = [
  {
    patterns: ["tmobile", "t-mobile"],
    path: "/assets/logos/carrier/tmobile.webp",
  },
  {
    patterns: ["at&t", "att", "at & t"],
    path: "/assets/logos/carrier/at&t.png",
  },
  {
    patterns: ["verizon"],
    path: "/assets/logos/carrier/verizon.png",
  },
];

export function carrierLogoSrc(carrier: string | null | undefined): string | null {
  if (!carrier || typeof carrier !== "string") return null;
  const n = carrier.toLowerCase().trim();
  for (const { patterns, path } of CARRIER_LOGO_MAP) {
    if (patterns.some((p) => n.includes(p) || p.includes(n))) return path;
  }
  return null;
}
